import React from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange
}) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };
  
  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;
  
  return (
    <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-2 mt-8" role="navigation" aria-label="صفحه‌بندی">
      <button
        onClick={handlePrevious}
        disabled={isFirstPage}
        className="w-full sm:w-auto px-6 py-3 min-h-[44px] bg-bg-secondary border border-border-default rounded-lg text-sm md:text-base text-text-primary hover:bg-bg-tertiary disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-base flex items-center justify-center gap-2 touch-manipulation"
        aria-label="صفحه قبل"
      >
        <ChevronRight className="w-5 h-5" aria-hidden="true" />
        <span className="font-medium">قبلی</span>
      </button>
      
      <span className="text-sm md:text-base text-text-secondary px-4 py-2" aria-current="page">
        صفحه {currentPage.toLocaleString('fa-IR')} از {totalPages.toLocaleString('fa-IR')}
      </span>
      
      <button
        onClick={handleNext}
        disabled={isLastPage}
        className="w-full sm:w-auto px-6 py-3 min-h-[44px] bg-bg-secondary border border-border-default rounded-lg text-sm md:text-base text-text-primary hover:bg-bg-tertiary disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-base flex items-center justify-center gap-2 touch-manipulation"
        aria-label="صفحه بعد"
      >
        <span className="font-medium">بعدی</span>
        <ChevronLeft className="w-5 h-5" aria-hidden="true" />
      </button>
    </div>
  );
};

export default Pagination;
